import React, { useContext } from 'react';
import { Box } from '@mui/material';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import { DataContext } from '../../context/DataContext';
import { getTokens } from '../../theme';

// Boton "Regresar" de las pantallas de detalle — ver
// design_handoff_crediapp_redesign/Detalle Credito CrediApp.dc.html:
// alto 40px, radio 11px, fondo var(--chip) con borde var(--chip-border),
// texto 13.5px/700 y chevron de 16px.
const BackButton = ({ onClick, label = 'Regresar' }) => {
	const { isDarkMode } = useContext(DataContext);
	const t = getTokens(isDarkMode);

	return (
		<Box
			onClick={onClick}
			sx={{
				display: 'inline-flex',
				alignItems: 'center',
				gap: '8px',
				height: '40px',
				padding: '0 14px',
				borderRadius: '11px',
				backgroundColor: t.chip,
				border: `1px solid ${t.chipLine}`,
				color: 'text.primary',
				fontWeight: 700,
				fontSize: 13.5,
				cursor: 'pointer',
				whiteSpace: 'nowrap',
				flexShrink: 0,
				'&:hover': { backgroundColor: t.field }
			}}
		>
			<ChevronLeftRoundedIcon sx={{ fontSize: 16 }} />
			{label}
		</Box>
	);
};

export default BackButton;
